import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import { task } from 'ember-concurrency';
import UserModel from 'cio/models/user';

export default class BackupCodesController extends Controller {
  @service router!: RouterService;

  declare model: { user: UserModel; codes: string[] };

  generateNewBackupCodesTask = task(async () => {
    await this.model.user.generateNewTwoFactorAuthenticationBackupCodes();
    this.router.transitionTo('settings.personal.security.new_backup_codes', {
      queryParams: { regenerating: true },
    });
  });
}
